import { render, staticRenderFns } from "./BankDetailsEditModal.vue?vue&type=template&id=c09409c6"
import script from "./BankDetailsEditModal.vue?vue&type=script&lang=js"
export * from "./BankDetailsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports